import { CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { DocManagerIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { GeometryManagerView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(geometryAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const geometryManagerViewKey = "geometry_modular_geometry/:brand/manager";
export const geometryManagerViewModule: ViewModule = {
  viewKey: geometryManagerViewKey,
  viewEl: <GeometryManagerView/>,
  displayNameI18nKey: "documentManager:viewName",
  menuIconEl: <DocManagerIcon/>,
  isAuthorized,
  translations,
};
